import compose from 'recompose/compose';
import { connect } from 'react-redux';
import branch from 'recompose/branch';
import renderNothing from 'recompose/renderNothing';
import withHandlers from 'recompose/withHandlers';
import isEmpty from 'lodash/isEmpty';

import { shouldShowBrandsOrCategories } from '../selectors';
import { getProductsBrands } from '../../../products/products/selectors';
import BrandsList from '../components/BrandsList';
import { setProductBrand } from '../actions';
import * as brandsSelectors from '../../../products/brands/selectors';

const BrandsListContainer = compose(
  connect(
    state => ({
      brands: brandsSelectors.getByIds(
        state,
        getProductsBrands(state)
      ),
      shouldShowBrandsOrCategories: shouldShowBrandsOrCategories(state),
    }),
    { setProductBrand },
  ),
  branch(
    props => !props.shouldShowBrandsOrCategories || isEmpty(props.brands),
    renderNothing,
  ),
  withHandlers({
    setProductBrand: props => id => () => props.setProductBrand(id),
  })
)(BrandsList);

export default BrandsListContainer;
